import {
  CALL_FOR_ACTION_REQUEST_ASYNC,
  COPY_CALL_FOR_ACTION_ASYNC,
  DELETE_CALL_FOR_ACTION_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
} from './constants'

export const fetchCallForAction = () => ({
  type: CALL_FOR_ACTION_REQUEST_ASYNC.INITIATE,
})
export const fetchCallForActionSuccess = (data) => ({
  type: CALL_FOR_ACTION_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
const fetchCallForActionCancel = () => ({
  type: CALL_FOR_ACTION_REQUEST_ASYNC.CANCEL,
})
export const fetchCallForActionError = (error) => ({
  type: CALL_FOR_ACTION_REQUEST_ASYNC.ERROR,
  error,
})

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })
const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

export const deleteCallForAction = (id) => ({
  type: DELETE_CALL_FOR_ACTION_ASYNC.INITIATE,
  payload: { id },
})
export const deleteCallForActionSuccess = () => ({
  type: DELETE_CALL_FOR_ACTION_ASYNC.SUCCESS,
})
export const deleteCallForActionError = (error) => ({
  type: DELETE_CALL_FOR_ACTION_ASYNC.ERROR,
  error,
})

export const copyCallForAction = (id) => ({
  type: COPY_CALL_FOR_ACTION_ASYNC.INITIATE,
  payload: { id },
})
export const copyCallForActionSuccess = () => ({
  type: COPY_CALL_FOR_ACTION_ASYNC.SUCCESS,
})
export const copyCallForActionError = (error) => ({
  type: COPY_CALL_FOR_ACTION_ASYNC.ERROR,
  error,
})

export default {
  // to props
  fetchCallForAction,
  fetchCallForActionCancel,
  paginateChange,
  searchChange,
  searchReset,
}
